import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { BackgroundBox, StyledPaper, ContentStack, CenteredBox } from './InitPageContainerNoFooter.styles';

type InitPageContainerProps = {
  children: React.ReactNode;
  title: string;
  cardHeight?: string;
};

export const InitPageContainerNoFooter = ({
  children,
  title,
  cardHeight,
}: InitPageContainerProps) => {
  const theme = useTheme();

  return (
    <BackgroundBox>
      <StyledPaper cardHeight={cardHeight}>
        <ContentStack>
          <Typography
            marginTop={theme.spacing(-3)}
            marginBottom={theme.spacing(6)}
            gutterBottom
            textAlign={'left'}
            width='100%'
            variant='h6'
          >
            {title}
          </Typography>

          {/* Middle Content - Centered */}
          <CenteredBox>
            {children}
          </CenteredBox>
        </ContentStack>
      </StyledPaper>
    </BackgroundBox>
  );
};